import { Component, OnInit } from '@angular/core';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { GetTemplateById, EditTemplate } from '../store/templates.actions';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationUtil, VALIDATION_MESSAGES } from "../../../../utils/validation.util";
import { map, first, take } from "rxjs/operators";


import {
  GetUserCapabilites
} from "src/app/login/store/auth.actions";
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-edit-template',
  templateUrl: './edit-template.component.html',
  styleUrls: ['./edit-template.component.scss']
})
export class EditTemplateComponent implements OnInit {
  
  id: string = '';
  TemplateForm: FormGroup;
  validationMsg = VALIDATION_MESSAGES;
  showPatternEdit = false;

  constructor(
    private store: Store<AppState>,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private ngxPermissionService: NgxPermissionsService,
    private fb: FormBuilder,
  ) {
    this.TemplateForm = this.fb.group({
      templateName: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])],
      subject: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])],
      content: ['', Validators.compose([
        Validators.required,
        ValidationUtil.cannotBeBlank,
      ])]
    });
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id')
    this.store.dispatch(new GetTemplateById(this.id))
    this.store.select(state => state.template.template).subscribe((response: any) => {
      this.TemplateForm.patchValue({
        templateName: response.displayName || '',
        subject: response.subject || '',
        content: response.content || '',
      });
    });

    this.store.dispatch(new GetUserCapabilites());
    this.store.select(store => store.auth.user['capabilities']).pipe(take(2)).subscribe(
        res => {
            // let capabilities = res[0].capabilities;
            const capabilities = (Object.keys(this.ngxPermissionService.getPermissions()) || []);
            if (capabilities.includes('patterns-management')) {
                this.showPatternEdit = true;
            }
    });


  }

  updateTemplate() {
    const payload = {
      templateName: this.TemplateForm.value.templateName.trim(),
      subject: this.TemplateForm.value.subject.trim(),
      content: this.TemplateForm.value.content.trim(),
    }
    this.store.dispatch(new EditTemplate(this.id, payload));
  }

  cancel() {
    this.location.back();
  }
}
